import * as React from 'react';
import { clsx } from 'clsx';
import styles from './Carousel.module.css';
import { IconChevronLeft16, IconChevronRight16 } from '../../../icons';
import { useCarouselButtons } from './hooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Carousel = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children
  } = _ref;
  const scrollableContainerRef = React.useRef(null);
  const {
    showLeftCarouselButton,
    showRightCarouselButton,
    onLeftCarouselButtonClick,
    onRightCarouselButtonClick
  } = useCarouselButtons({
    scrollableContainerRef,
    tabsRef: ref
  });
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("button", {
      className: clsx(styles['chevron-button'], styles['chevron-button--left'], {
        [styles['chevron-button--visible']]: showLeftCarouselButton
      }),
      onClick: onLeftCarouselButtonClick,
      children: /*#__PURE__*/_jsx(IconChevronLeft16, {})
    }), /*#__PURE__*/_jsx("div", {
      className: styles['scrollable-container'],
      ref: scrollableContainerRef,
      children: children
    }), /*#__PURE__*/_jsx("button", {
      className: clsx(styles['chevron-button'], styles['chevron-button--right'], {
        [styles['chevron-button--visible']]: showRightCarouselButton
      }),
      onClick: onRightCarouselButtonClick,
      children: /*#__PURE__*/_jsx(IconChevronRight16, {})
    })]
  });
});
Carousel.displayName = 'Carousel';